export default function SignUpSuccess(props) {
    
    return (
        <div align='center'>
            Registration successfull. Go back to <a href='/login'>login</a> page.
        </div>
    )
}
